import { Button, Divider, Input, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { FilterActionsWrapper, FilterOptionsWrapper } from 'ui/Filter';

function InputFilter({ value, placeholder, onFilterChange }) {
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setSearchValue(value);
  }, [value]);

  const handleFilter = () => {
    if (!searchValue) {
      return;
    }

    onFilterChange(searchValue);
  };

  const handleClear = () => {
    setSearchValue('');
    onFilterChange('');
  };

  return (
    <>
      <FilterOptionsWrapper>
        <Input
          autoFocus
          value={searchValue}
          placeholder={placeholder}
          onChange={(e) => setSearchValue(e.target.value)}
          onPressEnter={handleFilter}
        />
      </FilterOptionsWrapper>

      <Divider style={{ margin: '0' }} />

      <FilterActionsWrapper>
        <Space>
          <Button
            type="link"
            size="small"
            disabled={!searchValue}
            onClick={handleClear}
          >
            Сбросить
          </Button>
          <Button type="primary" size="small" onClick={handleFilter}>
            ОК
          </Button>
        </Space>
      </FilterActionsWrapper>
    </>
  );
}

export { InputFilter };
